import {useEffect, useState} from 'react';
import CinetyDefaultTemplate from '@/components/main/MyPlus/common/TemplateType/CinetyDefaultTemplate';
import useMainStore from '@/stores/main';
import {LIVE_SLIDE_CNT} from '@/constants/main';

const CinetyContentType = ({
  data,
  useSlider,
  rowCount,
  onChangeEnabled,
  log,
}) => {
  const [itemList, setItemList] = useState([]);
  const [displayedContent, setDisplayedContent] = useState([]);

  const {resizeMainLiveCount} = useMainStore();

  useEffect(() => {
    if (data) {
      if (data.length < 6) {
        onChangeEnabled(false);
      } else {
        onChangeEnabled(true);
      }

      const formattedContent = data.map((broadcast) => {
        const {
          readCnt, // 총 조회수
          episodeDate, // 날짜
          contentTitle, // 유저이름
          episodeNo, // 방송 번호
          hashtags,
          thumbUrl, //썸네일 주소
          title, // 방송제목
          duration,
          categoryName,
          profileImg,
          ...rest // 나머지 속성
        } = broadcast;

        // 새로운 객체를 반환
        return {
          ...broadcast,
          thumbnailSrc: thumbUrl, // 썸네일 이미지
          viewCount: readCnt, // 조회수
          registerDate: episodeDate, // 등록 일
          userNickname: contentTitle,
          duration: duration,
          title: title, // 방송 제목
          broadcastId: episodeNo, // 방송 ID
          categoryTags: [categoryName || ''],
          categoryName: categoryName,
          hashTags: hashtags,
          adminProfileImg: profileImg,
          userId: 'aforiginal',
        };
      });

      setItemList(formattedContent);
    }
  }, [data]);

  useEffect(() => {
    if (useSlider) {
      setDisplayedContent([...itemList.slice(0, LIVE_SLIDE_CNT)]);
    } else {
      const visibleListCount = resizeMainLiveCount * rowCount;
      setDisplayedContent([...itemList.slice(0, visibleListCount)]);
    }
  }, [itemList, resizeMainLiveCount, useSlider, rowCount]);

  return (
    <>
      <CinetyDefaultTemplate
        itemList={displayedContent}
        useSlider={useSlider}
        log={log}
      />
    </>
  );
};
export default CinetyContentType;
